// src/components/content/HktAiAssistant.tsx
import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthProvider';
import { buildLogoutUrl } from '../../utils/authHelper';
import language from '../../utils/LanguageSettings';

/**
 * HKT AI Assistant Integration
 * Verifies NowID session and redirects to AI assistant platform.
 * Uses AuthProvider for reliable session detection.
 */
const HktAiAssistant: React.FC = () => {
    const { ready, isLoggedIn, userData } = useAuth();
    const [npidMatching, setNpidMatching] = useState(false);
    const [loading, setLoading] = useState<boolean>(true);
    const logoutUrl = buildLogoutUrl(language);

    useEffect(() => {
        if (!ready) return;

        if (!isLoggedIn) {
            setLoading(false);
            setNpidMatching(false);
            return;
        }

        const npid = userData?.npid || '';
        const nowSessionId = userData?.nowSessionId || (window as any).__NOWSESSIONID;

        // Get URL parameter 'npid' from URL
        const urlParams = new URLSearchParams(window.location.search);
        const urlNpid = urlParams.get('npid');

        console.log('HktAiAssistant: URL npid:', urlNpid);
        console.log('HktAiAssistant: auth npid:', npid);
        console.log('HktAiAssistant: npids match:', urlNpid === npid);

        // Check npid logic: if no URL npid OR npids match, proceed
        if (!urlNpid || (urlNpid && npid && urlNpid === npid)) {
            setNpidMatching(true);

            // Set cross-subdomain cookie for qa-hktaiasst.now.com
            try {
                if (nowSessionId) {
                    const cookieValue = encodeURIComponent(nowSessionId);
                    // Long-lived cookie for AI assistant cross-domain support
                    document.cookie = `nowSessionId=${cookieValue};domain=.now.com;path=/;SameSite=None;Secure;max-age=315569260`;
                } else {
                    console.warn('HktAiAssistant: nowSessionId not present; redirecting without setting cookie');
                }
            } catch (err) {
                console.warn('HktAiAssistant: failed to set cookie', err);
            }

            // Redirect to AI assistant
            window.location.href = 'https://www.nowtv.now.com/site/astro-ai/';
        } else {
            // URL npid exists but doesn't match
            setNpidMatching(false);
            setLoading(false);
        }
    }, [ready, isLoggedIn, userData?.npid, userData?.nowSessionId]);

    const handleLoginAgain = () => {
        if (logoutUrl) {
            window.location.href = logoutUrl;
        }
    };

    if (loading || !ready) {
        return (
            <>
                <div id="loader">
                    <div className="spinner-border"></div>
                </div>
            </>
        );
    }

    if (!npidMatching) {
        return (
      <>
        <style>{`
          .btn.btn-primary {
            background-color: #ef9528;
            color: #fff;
            border: none;
          }
        `}</style>
        <section id="main-content">
          <div className="container-fluid my-5">
            <div className="page-wrapper text-center">
                <div className="heading mt-2 mb-5">
                    <h2>Please login with the Now ID from your Now TV App</h2>
                </div>
                <button className="btn btn-primary" onClick={handleLoginAgain}>
                    Login Again
                </button>
            </div>
        </div>
        </section>
      </>
        );
    }

    // Redirecting state
    return (
            <>
                <div id="loader">
                    <div className="spinner-border"></div>
                </div>
            </>
    );
};

export default HktAiAssistant;
